export default __webpack_public_path__ + "static/media/parada_accessible_positiu.f42ca1eb.png";